import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {InsuranceCompanyService} from "../../../shared/services/insurance-company.service";
import {from, Observable, ReplaySubject} from "rxjs";
import {delay, filter, finalize, first, take, takeUntil, tap} from "rxjs/operators";
import {Dictionary} from "../../../shared/interface/dictionary";
import {
  CLIENT_TYPE_OFWCA, CLIENT_TYPE_PARTNER,
  COMMISSION_IMPORT_ROW_STATUS_NEW,
  COMMISSION_IMPORT_ROW_STATUS_REJECTED,
  COMPANY_ASF,
  COMPANY_ASF_PREMIUM, COMPANY_MULTISFERA,
  DictService
} from "../../../shared/services/dict.service";
import {HttpErrorResponse} from "@angular/common/http";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {LinkToPortal} from "../../../shared/interface/linkToPortal";


@Component({
  selector: 'app-add-insurance-company',
  templateUrl: './add-insurance-company.component.html',
  styleUrls: ['./add-insurance-company.component.scss']
})
export class AddInsuranceCompanyComponent implements OnInit, AfterViewInit, OnDestroy  {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() insuranceCompany?: Observable<InsuranceCompany>;
  @Output() closeModification = new EventEmitter<any>();

  insuranceCompanyObject?: InsuranceCompany = null;
  insuranceCompanyForm: FormGroup;
  dictType: string;
  keyControl: FormControl;
  nameControl: FormControl;
  fullNameControl: FormControl;
  typeControl: FormControl;
  asfControl: FormControl;
  asfPremiumControl: FormControl;
  multisferaControl: FormControl;
  inactiveControl: FormControl;
  filterControl: FormControl;
  identifiersControl: FormControl;
  loginControl: FormControl;
  cessionLoginControl: FormControl;
  registrationIdTypesControl: FormControl;
  contactEmailControl: FormControl;
  contactHelplineControl: FormControl;
  items: Dictionary[] = [];
  sortItems: [Dictionary[]] = [[]];
  selectedValues = [];
  loginsControl: FormControl;
  loginsHelpControl: FormControl;
  hasAsf = false;
  hasMultisfera = false;
  hasAsfPremium = false;
  linkToPortalFormArray: FormGroup[] = [];
  cessionLoginsControl: FormControl;
  cessionControl: FormControl;
  cessionLoginsHelpControl: FormControl;
  requiredLifeMinutesControl: FormControl;
  requiredLifeHoursPartControl: FormControl;
  requiredLifeMinutesPartControl: FormControl;
  requiredAssetsMinutesControl: FormControl;
  requiredAssetsHoursPartControl: FormControl;
  requiredAssetsMinutesPartControl: FormControl;
  requiredGeneralMinutesControl: FormControl;
  requiredGeneralHoursPartControl: FormControl;
  requiredGeneralMinutesPartControl: FormControl;


  constructor(
    private insuranceCompanyService: InsuranceCompanyService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private dictService: DictService,
    private snack: MatSnackBar,

  ) {
    this.filterControl = fb.control('');
    this.loadItems("registration_id_type");
    this.insuranceCompanyForm = this.fb.group({
      key: this.keyControl = this.fb.control('', []),
      name: this.nameControl = this.fb.control('', [Validators.required]),
      fullName: this.fullNameControl =  this.fb.control('', [Validators.required]),
      asf: this.asfControl = this.fb.control(false),
      asfPremium: this.asfPremiumControl = this.fb.control(false),
      type: this.typeControl = this.fb.control('', [Validators.required]),
      inactive: this.inactiveControl = this.fb.control(false),
      registrationIdTypes: this.registrationIdTypesControl = this.fb.control(''),
      logins: this.loginsControl = fb.control(''),
      loginsHelp: this.loginsHelpControl = fb.control([]),
      cessionLogins: this.cessionLoginsControl = fb.control(''),
      cession: this.cessionControl = this.fb.control(false),
      cessionLoginsHelp: this.cessionLoginsHelpControl = fb.control([]),
      linkToPortal: fb.array(this.linkToPortalFormArray, []),
      contactEmail: this.contactEmailControl = fb.control(''),
      contactHelpline: this.contactHelplineControl = fb.control(''),
      requiredAssetsMinutes: this.requiredAssetsMinutesControl = fb.control(0),
      requiredLifeMinutes: this.requiredLifeMinutesControl = fb.control(0),
      requiredGeneralMinutes: this.requiredGeneralMinutesControl = fb.control(0),
      multisfera: this.multisferaControl = this.fb.control(false),

    });
    this.identifiersControl = this.fb.control(false);
    this.loginControl = this.fb.control(false);
    this.cessionLoginControl = this.fb.control(false);
    this.requiredAssetsHoursPartControl = fb.control(0);
    this.requiredAssetsMinutesPartControl = fb.control(0);
    this.requiredLifeHoursPartControl = fb.control(0);
    this.requiredLifeMinutesPartControl = fb.control(0);
    this.requiredGeneralMinutesPartControl = fb.control(0);
    this.requiredGeneralHoursPartControl = fb.control(0);

  }

  loadItems(dictType: string): void {
    this.dictService.getDictSubject()
      .pipe(
        take(1)
      )
      .subscribe((items: Dictionary[]) => {
        from(items)
          .pipe(
            filter((e: Dictionary) => e.type === dictType),
            tap((e: Dictionary) => {
              if (!this.items.some((search: Dictionary) => search.id === e.id)) {
                this.items.push(e);
              }
            }),
          ).subscribe();
      });
    this.sort();
  }
  sort(): void {
    this.sortItems. splice(0, this.sortItems.length);
    let x = [];
    let y = 0;
    this.items.forEach((dict: any) => {
      x.push(dict);
      y = y + 1;
      if (y === 5){
        this.sortItems.push(x);
        y = 0;
        x = [];
      }
    });
    this.sortItems.push(x);
  }

  ngOnInit(): void {

    this.identifiersControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        this.sort();
        if (this.identifiersControl.value){
          this.loginControl.setValue(false);
          this.cessionLoginControl.setValue(false);
        }
      });
    this.loginControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        this.sort();
        if (this.loginControl.value){
          this.identifiersControl.setValue(false);
          this.cessionLoginControl.setValue(false);
        }
      });
    this.cessionLoginControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        this.sort();
        if (this.cessionLoginControl.value){
          this.identifiersControl.setValue(false);
          this.loginControl.setValue(false);
        }
      });
  }
  add(dict: Dictionary): void{
    if (this.selectedValues.indexOf(dict.key) === -1) {
      this.selectedValues.push(dict.key);
    }else{
      this.selectedValues.splice(this.selectedValues.indexOf(dict.key),1);
    }
  }
  isSelect(row?: string): boolean {
    let isSelect = false;
    this.selectedValues.forEach((h: string) => {
      if (row === h){
        isSelect = true;
      }
    });
    return isSelect;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    if (this.insuranceCompany) {
      this.insuranceCompany
        .pipe(
          first(),
          delay(0),
          tap((insuranceCompany: InsuranceCompany) => {
            if (insuranceCompany === null) {
              return;
            }
            this.insuranceCompanyObject = insuranceCompany;
            this.insuranceCompanyObject.companies.forEach((e: Dictionary) => {
              if (e.key === COMPANY_ASF) {
                this.hasAsf = true;
              }

              if (e.key === COMPANY_ASF_PREMIUM) {
                this.hasAsfPremium = true;
              }

              if (e.key === COMPANY_MULTISFERA) {
                this.hasMultisfera = true;
              }
            });

            this.selectedValues = insuranceCompany.registrationIdTypes;
            let array = [];
            insuranceCompany.logins.forEach((id: string) => {
              this.dictService.getDict(Number(id))
                .subscribe((dict: Dictionary) => {
                  array.push(dict);
                });
            });
            let arrayCession = [];
            insuranceCompany.cessionLogins.forEach((id: string) => {
              this.dictService.getDict(Number(id))
                .subscribe((dict: Dictionary) => {
                  arrayCession.push(dict);
                });
            });


            if (insuranceCompany.requiredAssetsMinutes) {
              const hours = Math.floor(insuranceCompany.requiredAssetsMinutes / 60);
              const minutes = insuranceCompany.requiredAssetsMinutes % 60;
              this.requiredAssetsHoursPartControl.setValue(hours);
              this.requiredAssetsMinutesPartControl.setValue(minutes);
            }

            if (insuranceCompany.requiredLifeMinutes) {
              const hours = Math.floor(insuranceCompany.requiredLifeMinutes / 60);
              const minutes = insuranceCompany.requiredLifeMinutes % 60;
              this.requiredLifeHoursPartControl.setValue(hours);
              this.requiredLifeMinutesPartControl.setValue(minutes);
            }

            if (insuranceCompany.requiredGeneralMinutes) {
              const hours = Math.floor(insuranceCompany.requiredGeneralMinutes / 60);
              const minutes = insuranceCompany.requiredGeneralMinutes % 60;
              this.requiredGeneralHoursPartControl.setValue(hours);
              this.requiredGeneralMinutesPartControl.setValue(minutes);
            }

            this.insuranceCompanyForm.reset({
              key: insuranceCompany.key,
              name: insuranceCompany.name,
              fullName: insuranceCompany.fullName,
              asf: this.hasAsf,
              asfPremium: this.hasAsfPremium,
              multisfera: this.hasMultisfera,
              type: insuranceCompany.type?.key,
              inactive: !insuranceCompany.inactive,
              registrationIdTypes: insuranceCompany.registrationIdTypes,
              logins: insuranceCompany.logins,
              loginsHelp: array.map((dict: Dictionary) => dict.id) ?? [],
              contactHelpline: insuranceCompany.contactHelpline,
              contactEmail: insuranceCompany.contactEmail,
              cession: insuranceCompany.cession,
              cessionLogins: insuranceCompany.cessionLogins,
              cessionLoginsHelp: arrayCession.map((dict: Dictionary) => dict.id) ?? [],
              requiredAssetsMinutes: insuranceCompany.requiredAssetsMinutes || 0,
              requiredLifeMinutes: insuranceCompany.requiredLifeMinutes || 0,
              requiredGeneralMinutes: insuranceCompany.requiredGeneralMinutes || 0,
            });
            this.asfControl.disable();
            this.asfPremiumControl.disable();
            this.multisferaControl.disable();

            insuranceCompany.linkToPortal
              .forEach((link: LinkToPortal) => this.addlink(link.name,
                link.link));

          }),
          delay(0),
          tap(() => this.insuranceCompanyForm.markAllAsTouched())
        )
        .subscribe();
    }
  }

  updateRequiredMinutes(): void {
    this.requiredAssetsMinutesControl.setValue(
      (this.requiredAssetsHoursPartControl.value * 60) + this.requiredAssetsMinutesPartControl.value
    );

    this.requiredLifeMinutesControl.setValue(
      (this.requiredLifeHoursPartControl.value * 60) + this.requiredLifeMinutesPartControl.value
    );

    this.requiredGeneralMinutesControl.setValue(
      (this.requiredGeneralHoursPartControl.value * 60) + this.requiredGeneralMinutesPartControl.value
    );
  }

  save(): void {
    this.updateRequiredMinutes();
    this.registrationIdTypesControl.setValue(this.selectedValues.toString());
    if (this.loginsHelpControl.value === null){
      this.loginsControl.setValue(null);
    }else {
      this.loginsControl.setValue(this.loginsHelpControl.value.toString());
    }
    if (this.cessionLoginsHelpControl.value === null){
      this.cessionLoginsControl.setValue(null);
    }else {
      this.cessionLoginsControl.setValue(this.cessionLoginsHelpControl.value.toString());
    }

    if (!this.insuranceCompanyForm.valid) {
      this.insuranceCompanyForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.insuranceCompanyService.sendForm(this.insuranceCompanyForm.getRawValue(),
      this.insuranceCompanyObject ? this.insuranceCompanyObject.id.toString() : null)
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open( this.insuranceCompanyObject ? 'Pomyślnie zaktualizowano TU' : 'Pomyślnie utworzono TU', '', {
          duration: 2000,
        });
        if (this.insuranceCompanyObject) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/tu']);
        }
      }, (error: HttpErrorResponse) => {
        this.snack.open( 'Podczas tworzenia obiektu TU wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      })
    ;
  }

  addlink(name?: string, link?: string): void {
    this.linkToPortalFormArray.push(new FormGroup({
      name: new FormControl(name || '', [Validators.required]),
      link: new FormControl(link || '', [Validators.required])
    }));

    this.updateLinkFormArray();
  }

  updateLinkFormArray(): void {
    this.insuranceCompanyForm.setControl('linkToPortal', new FormArray(this.linkToPortalFormArray, []));
  }

  removeLink(index: number): void {
    this.linkToPortalFormArray.splice(index, 1);
    this.updateLinkFormArray();
  }
  cancel(): void {
    if (!this.insuranceCompanyObject) {
      this.router.navigate(['/tu']);
    } else {
      this.closeModification.emit();    }
  }
}
